import React, { useEffect, useState } from 'react';
import { baseUrlUser } from './common';
import './userlist.css'; // Import CSS here

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [product, setProduct] = useState('Lens'); // Default product
  const [page, setPage] = useState(0); // zero-based page index
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const token = localStorage.getItem('treziAccessToken');

  const fetchUsers = async () => {
    try {
      const url = `${baseUrlUser}users/signup/list?page=${page}&pageSize=${pageSize}&product=${encodeURIComponent(product)}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 404) {
        throw new Error('Users not found.');
      }
      if (!response.ok) {
        const err = await response.text();
        throw new Error(err);
      }

      const data = await response.json();
      setUsers(data.users || []);
      if (data.meta && data.meta.totalPages) {
        setTotalPages(data.meta.totalPages);
      } else {
        setTotalPages(0);
      }
    } catch (err) {
      console.error(err);
      alert(err.message);
      setUsers([]);
      setTotalPages(0);
    }
  };

  // Fetch users whenever page, pageSize, or product changes
  React.useEffect(() => {
    fetchUsers();
  }, [page, pageSize]);

  // Handle manual page input (optional)
  const handlePageInput = (e) => {
    let val = Number(e.target.value);
    if (!isNaN(val) && val >= 1 && val <= totalPages) {
      setPage(val - 1); // converting 1-based input to zero-based index
    }
  };

  // Handle manual pageSize input (optional)
  const handlePageSizeInput = (e) => {
    let val = Number(e.target.value);
    if (!isNaN(val) && val > 0 && val <= 100) {
      setPageSize(val);
      setPage(0); // reset to first page when page size changes
    }
  };

  return (
    <div className="userlist-page">

    <div className="userlist-container">
      <h2 className="userlist-title">Signed-up Users</h2>

      <div className="userlist-filters">
        <label htmlFor="product">Product: </label>
        <input
          type="text"
          id="product"
          value={product}
          onChange={(e) => setProduct(e.target.value)}
          className="userlist-input"
        />

        <label htmlFor="pageSize">Page Size: </label>
        <input
          type="number"
          id="pageSize"
          value={pageSize}
          onChange={handlePageSizeInput}
          min={1}
          max={100}
          className="userlist-input pageSize-input"
        />

        <button onClick={fetchUsers} className="userlist-button">Fetch Users</button>
      </div>

      <ul className="userlist-ul">
        {users.length > 0 ? (
          users.map((user, index) => (
            <li key={index} className="userlist-li">
              {user.email || user.clientId || 'No email/clientId'}
            </li>
          ))
        ) : (
          <li className="userlist-li no-users">No users found</li>
        )}
      </ul>

      <div className="userlist-pagination">
        <button
          disabled={page <= 0}
          onClick={() => setPage((p) => Math.max(p - 1, 0))}
          className="userlist-button"
        >
          Prev
        </button>

        <input
          type="number"
          min={1}
          max={totalPages}
          value={page + 1}
          onChange={handlePageInput}
          className="userlist-page-input"
        />

        <span className="userlist-page-info">
          of {totalPages} {totalPages === 1 ? 'page' : 'pages'}
        </span>

        <button
          disabled={page >= totalPages - 1}
          onClick={() => setPage((p) => Math.min(p + 1, totalPages - 1))}
          className="userlist-button"
        >
          Next
        </button>
      </div>
    </div>
      </div>

  );
};

export default UsersList;
